export default "__VITE_ASSET__BXzpbFsK__"